export default "__VITE_ASSET__CCz1Lwyi__"